/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import {getAssetDetailsContentStyles} from '@ion/dls/src/components/assetdetails/current/assetDetailsContentStyles';

/**
 * Returns the current theme style of the SC sensor status last report time
 * (Shock, Tilt and Current Sensor Status) - the shared uppercase label
 * typography without the legacy side padding. The label's color is left
 * out, so each status keeps its own semantic (normal/alert) time color.
 *
 * Returned as a style object, not a `makeStyles` hook, so it is spread into
 * each status's own sheet - a separate shared sheet is created before the
 * importing component's sheet and so would lose to its legacy time class.
 *
 * ```typescript
 *
 *   import {getCurrentStatusTimeStyles} from './statusTimeStyles';
 *   ...
 *
 *   const useStyles = makeStyles(() => ({
 *     currentTimeText : getCurrentStatusTimeStyles()
 *   }));
 *
 * ```
 *
 * @returns The current theme status time text style object.
 */
export const getCurrentStatusTimeStyles = () => {
  const {color, ...labelTypography} = getAssetDetailsContentStyles().label;
  return {
    ...labelTypography,
    padding : 0
  };
};

export default getCurrentStatusTimeStyles;
